define('PartLookup.Form.View', [
	'Backbone',
	'Backbone.View',
	'Configuration',
	'Session',
	'SCView',
	'SCFormView',

	'PartLookupSearcher.View',
	'partlookup_model_form.tpl',
	
  'Utils',
	'jQuery',
	'underscore'
], function (
  Backbone,
  BackboneView,
  Configuration,
  Session,
  SCViewModule,
  SCFormViewModule,

  PartLookupSearcherView,
  partlookup_model_form_tpl,
  
  Utils,
  jQuery,
  _
) {
	'use strict';

	// var SCFormView = SCFormViewModule.SCFormView;
  // var SCView = SCViewModule.SCView;
	var SCFormView = SCViewModule.SCView;

	function PartLookupFormView(options) {
		SCFormView.call(this, options);

    this.application = options.application;

    this.itemsSearcherComponent = new PartLookupSearcherView({
      minLength: Configuration.get('typeahead.minLength', 3),
      maxLength: Configuration.get('searchPrefs.maxLength', 0),
      limit: Configuration.get('typeahead.maxResults', 10),
      highlight: Configuration.get('typeahead.highlight', true),
      application: this.application
    });

    this.itemsSearcherComponent.on('itemSelected', this.onItemSelected, this);
    this.itemsSearcherComponent.on('keyUp', this.showReset, this);
    this.itemsSearcherComponent.on('keyDown', this.cleanSearchOnEnter, this);

    
    // Listening the magnifying glass interactions
    this.application.getLayout().on('toggleModelSearcher', this.toggleModelSearcher, this);
    this.application.getLayout().on('hideModelSearcher', this.hideModelSearcher, this);
	}

	PartLookupFormView.prototype = Object.create(SCFormView.prototype);

	_.extend(PartLookupFormView.prototype, {

		constructor: PartLookupFormView,

		template: partlookup_model_form_tpl,

		getEvents: function () {
			return {
				'submit form': 'saveForm',
        'submit [data-action="model-part-search-input"]': 'searchEventHandler',
        'click [data-type="model-part-reset"]': 'resetHandle'
			};
		},

    toggleModelSearcher: function () {
      var element = this.$('.model-part-search-input');
      element.toggle();
      if (element.css('display') !== 'none') {
        this.itemsSearcherComponent.cleanSearch(true);
        this.itemsSearcherComponent.setFocus();
      }
      element.toggleClass('active');
    },

    hideModelSearcher: function () {
      var element = this.$('.model-part-search-input');
      element.hide();
      element.removeClass('active');
    },

    showReset: function (event_properties) {
      if (event_properties.currentQuery) {
        this.$('[data-type="model-part-reset"]').show();
      } else {
        this.$('[data-type="model-part-reset"]').hide();
      }
    },

    cleanSearchOnEnter: function (event_properties) {
      if (event_properties.eventObject.keyCode === 27) {
        this.$('[data-type="model-part-reset"]').hide();
        this.itemsSearcherComponent.cleanSearch();
      }
    },

    resetHandle: function () {
      this.$('[data-type="model-part-reset"]').hide();
      this.itemsSearcherComponent.cleanSearch();
    },

    showSiteSearch: function (dontFocus) {
      this.$('[data-type="model-part-reset"]').hide();
      this.itemsSearcherComponent.cleanSearch(true);

      if (!dontFocus) {
        this.itemsSearcherComponent.setFocus();
      }
    },

    searchEventHandler: function (e) {
      e.preventDefault();

      var search_term = this.itemsSearcherComponent.getCurrentQuery();

      if (search_term.length < 1) {
        return;
      }

      this.itemsSearcherComponent.cleanSearch();

      // this.executeSearch(search_term);
      this._executeSearch(search_term);
    },

    _executeSearch: function (search_term) {

      // If we are not in Shopping we have to redirect to it
      if ( Utils.getPathFromObject(Configuration, 'currentTouchpoint') !== 'home' ) {
        // we called this using fragment instead of # because bridged domain
        window.location.href = Utils.addParamsToUrl(
          Session.get('touchpoints.home'), {
            fragment: '/model-search/' + search_term,
          }
        );
      }
      // Else we stay in the same app
      else {

				Backbone.history.navigate('/model-search/' + search_term, {
					trigger: true,
				});


      }
    },

    onItemSelected: function (result) {

        var item = result.selectedItem;
        var collection = result.collection;
        var query = result.currentQuery;
        debugger;
        this.$('[data-type="model-part-reset"]').hide();
        this.itemsSearcherComponent.cleanSearch(true);

        if (item) {

            // CHANGED: use matchedPath if available (set by PartLookupSearcher.View),
            // otherwise check both model number fields
            var uri;

            if (result.matchedPath) {
                // Trust the path already resolved in PartLookupSearcher.View
                uri = result.matchedPath;
            } else {
                // Fallback: check custitem_sep_parent_model_number2 first if query matches it
                var field2 = item.get('custitem_sep_parent_model_number2');
                var field1 = item.get('custitem_sep_parent_model_number');

                if (!!query && !!field2 && field2.includes(query)) {
                    uri = field2;
                } else {
                    uri = item.get('Model') || field1;
                }
            }

            var path = '/model-search/' + uri;

            if (Configuration.get('currentTouchpoint', '') !== 'home') {
                window.location.href = Utils.addParamsToUrl(
                    Session.get('touchpoints.home'),
                    { fragment: path }
                );
            } else {
                Backbone.history.navigate(path, { trigger: true });
            }
        }

        else {
            if (!collection.length && result.isResultCompleted) {
                return false;
            }
            this._executeSearch(query);
        }
    },

    /*onItemSelected: function (result) {

      var item = result.selectedItem;
      var collection = result.collection;
      var query = result.currentQuery;

      this.$('[data-type="model-part-reset"]').hide();
      this.itemsSearcherComponent.cleanSearch(true);

      if (item) {
        var uri = item.get('Model') || item.get('custitem_sep_parent_model_number2');
        // var path = '/model-search/' + item.get('Model');
        var path = '/model-search/' + uri;

        if (Configuration.get('currentTouchpoint', '') !== 'home') {
          // we called this using fragment instead of # because bridged domain
          window.location.href = Utils.addParamsToUrl(
            Session.get('touchpoints.home'),
            {
              fragment: path,
            }
          );
        } else {
          Backbone.history.navigate(path, { trigger: true });
        }
      }
      
      else {

        if (!collection.length && result.isResultCompleted) {
          return false;
        }

        this._executeSearch(query);
      }
    },*/

    getCurrentSearchOptions: function () {
      var newOptions = [];
      var currentOptions = Utils.parseUrlOptions(window.location.href);

      _.each(currentOptions, function (value, key) {
        var lowerCaseKey = key.toLowerCase();

        if (
          lowerCaseKey === 'order' ||
          lowerCaseKey === 'show' ||
          lowerCaseKey === 'display'
        ) {
          newOptions.push(lowerCaseKey + '=' + value);
        }
      });

      var newOptionsStr = newOptions.join('&');

      if (newOptionsStr.length > 0) {
        newOptionsStr = '&' + newOptionsStr;
      }

      return newOptionsStr;
    },

    getChildViews: function() {
      var self = this;

      return {
        PartLookupSearcherView: function() {
          return self.itemsSearcherComponent;
        }
      }
    },

    getContext: function () {
      return {};
    },

    destroy: function () {
      console.log('destory form view')
      // SCFormView.call(this, options);
      // BackboneView.prototype.destroy.apply(this, arguments);
      // SCFormView.destroy.call(this, arguments);
      SCFormView.call(this);

      this.itemsSearcherComponent.off('itemSelected');
      this.itemsSearcherComponent.off('keyUp');
      this.itemsSearcherComponent.off('keyDown');
    },
    
		saveForm: function (event) {
			event.preventDefault();

			// var modelName = jQuery('input[name="sep-partlookup-search"]').val();
			var modelName = jQuery('[data-type="model-part-search-input"]').val();

			if (modelName.length > 0) {
				Backbone.history.navigate('#model-search/' + modelName, {
					trigger: true,
				});
			}

			return null;
		},

	});

	return PartLookupFormView;
});
